module.exports = __webpack_public_path__ + "img/ConventionalHardwareParitallyClosesResorptionGaps.ef362a03.jpg";